import {useMemo} from 'react'
import clsx from 'clsx'
import parse, {
    attributesToProps,
    DOMNode,
    domToReact,
    HTMLReactParserOptions,
} from 'html-react-parser'
import {ElementType} from 'domelementtype'

type ProductTypeDescriptionProps = {
    children: string
}

const ProductTypeDescription = ({children}: ProductTypeDescriptionProps) => {
    return useMemo(() => parse(children, parseOptions), [children])
}

const parseOptions: HTMLReactParserOptions = {
    replace: (domNode) => {
        if (domNode.type === ElementType.Tag) {
            const props = attributesToProps(domNode.attribs)

            if (domNode.name === 'ul') {
                return (
                    <ul
                        {...props}
                        className={clsx(
                            'list-disc mt-2 marker:text-green-600 marker:text-lg',
                            props.className
                        )}
                    >
                        {domToReact(domNode.children as DOMNode[], parseOptions)}
                    </ul>
                )
            }

            if (domNode.name === 'li') {
                return (
                    <li {...props} className={clsx('ml-5 pl-1', props.className)}>
                        {domToReact(domNode.children as DOMNode[], parseOptions)}
                    </li>
                )
            }
        }
    },
}

export default ProductTypeDescription
